import ApiService from '../services/ApiService';

export default class CelebrityCampaignRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    deleteCelebrityCampaigns(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete(`celebrity-campaigns/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCelebrityCampaigns(sort = '') {
        return new Promise((resolve, reject) => {
            this.apiService
                .get(`celebrity-campaigns?sort=${sort}`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    storeCelebrityCampaign(programId, userId) {
        return new Promise((resolve, reject) => {
            const data = {
                program_id: programId,
                user_id: userId
            };

            this.apiService
                .post('celebrity-campaigns', data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateCelebrityCampaign(id, programId, userId) {
        return new Promise((resolve, reject) => {
            const data = {
                program_id: programId,
                user_id: userId
            };

            this.apiService
                .put(`celebrity-campaigns/${id}`, data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}
